/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_MonthlyInputs */

const en_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const de_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const fr_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

const es_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const it_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensile`)
};

const nl_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijks`)
};

const pl_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesięcznie`)
};

const fi_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuukausittain`)
};

const da_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedligt`)
};

const sv_common_monthly = /** @type {(inputs: Common_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månadsvis`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Common_MonthlyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_monthly = /** @type {((inputs?: Common_MonthlyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_MonthlyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_monthly(inputs)
	if (locale === "fr") return fr_common_monthly(inputs)
	if (locale === "es") return es_common_monthly(inputs)
	if (locale === "it") return it_common_monthly(inputs)
	if (locale === "nl") return nl_common_monthly(inputs)
	if (locale === "pl") return pl_common_monthly(inputs)
	if (locale === "fi") return fi_common_monthly(inputs)
	if (locale === "da") return da_common_monthly(inputs)
	if (locale === "sv") return sv_common_monthly(inputs)
	return en_common_monthly(inputs)
});